<script>
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['getPartner']),
    },
    methods: {
      ...mapMutations(['setPartner'])
    },
    name: 'GetPartner'
  }
</script>
